<script setup lang="ts">
import { onMounted, ref } from "vue";
import { CmnhDropdown } from "@cmnhospitals/components-vue";

// Props with optional modelValue to support search forms with empty initial state
defineProps<{
    modelValue?: string;
    hideLabel?: boolean;
}>();

const emit = defineEmits<{
    (e: "update:modelValue", value: string): void;
}>();

const states = ref<{ field: string; value: string }[]>([]);

// Validate and emit the selected state value
const handleStateChange = (value: string | number | boolean) => {
    // Convert to string and validate it's a valid state abbreviation
    const stringValue = String(value);
    emit('update:modelValue', stringValue);
};

onMounted(async () => {
    try {
        // Fetch state list from local static asset (security: prevents external XSS vector)
        const response = await fetch("/data/states.json");

        // Validate response to prevent malformed data injection
        if (!response.ok) {
            throw new Error(`Failed to load states: ${response.statusText}`);
        }

        const raw = await response.json();

        // Validate data structure before mapping
        if (!Array.isArray(raw)) {
            throw new Error("Invalid states data format");
        }

        // Map to dropdown format: field = display text, value = abbreviation
        states.value = raw.map((state: { name: string; abbreviation: string }) => ({
            field: state.name,
            value: state.abbreviation,
        }));
    } catch (e) {
        console.error("Failed to fetch states:", e);
    }
});
</script>

<template>
    <CmnhDropdown
        label="Office State"
        :options="states"
        :model-value="modelValue"
        :placeholder="'Office State'"
        :hide-label="hideLabel"
        @update:model-value="handleStateChange"
    />
</template>
